import baseUrl from '../config/env'
// 配置API接口地址
var root = baseUrl

// 引用axios
var axios = require('axios')
// 自定义判断元素类型JS
function toType (obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull (o) {
    for (var key in o) {
        if (o[key] === null) {
            delete o[key]
        }
        if (toType(o[key]) === 'string') {
            o[key] = o[key].trim()
        } else if (toType(o[key]) === 'object') {
            o[key] = filterNull(o[key])
        } else if (toType(o[key]) === 'array') {
            o[key] = filterNull(o[key])
        }
    }
    return o
}


function apiAxios (method, url, params, success, failure) {
    if (params) {
        params = filterNull(params)
    }
    axios({
        method: method,
        url: url,
        data: method === 'POST'  ? params : null,
        params: method === 'GET'  ? params : null,
        baseURL: root,
        withCredentials: true
    }).then(function (res) {
        console.log(res);
        if (res.status === 200) {
            if (success) {
                success(res.data)
            }
        } else {
            if (failure) {
                failure(res.data)
            } else {
                window.alert('error: ' + JSON.stringify(res.data))
            }
        }
    }).catch(function (err) {
        let res = err.response
        if (err && res) {
            if (res.status === 403){
                localStorage.removeItem('curUserCompany');
                window.location.href = "/login.html";
                return;
            }
            window.alert('api error, HTTP CODE: ' + res.status)
            return
        }
    })
}

// 返回在vue模板中的调用 接口
export default {
    get: function (url, params, success, failure) {
        return apiAxios('GET', url, params, success, failure)
    },
    post: function (url, params, success, failure) {
        return apiAxios('POST', url, params, success, failure)
    },
    getUrlStr: function(name){
        /**
         * 获取地址栏参数
         */
        let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)","i");
        if(reg.test(window.location.href)){
            return unescape(RegExp.$2.replace(/\+/g," "))
        }
        return undefined
    }

}